module.exports = __webpack_public_path__ + "img/line_multi.535eee12.svg";